window["ThemeComponent_ProductTile"] = ({
  product,
  variant,
  cart_qty,
  mode,
}) => {
  return {
    mode: mode,
    productForms: null,
    productRoot: null,
    product: product,
    current_variant: variant,
    current_media: window.matchMedia("(max-width: 767px)").matches ? 1 : 2,
    hover: false,
    loading: false,
    quantity: 1,
    cart_qty: cart_qty,
    total_qty: 0,
    addedToCart: false,
    cartAddErrorMessage: null,
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get current_price() {
      return this.current_variant.price;
    },
    formatMoney(price, moneyFormat = theme.defaultMoneyFormat) {
      return formatMoney(price, moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      this.total_qty = this.cart_qty + this.quantity;

      window.addEventListener("switch:modalcart:cartqtychange", (e) => {
        if (!e.detail.response) return;

        // Qty was updated in cart
        if (e.detail.response.item_count !== 0) {
          const isVariant = e.detail.response.items.find(
            (item) => item.variant_id === this.current_variant.id,
          );
          if (isVariant && isVariant.id === this.current_variant.id) {
            // The variant is still in cart
            this.cart_qty = isVariant.quantity;
          } else {
            // The variant was removed from cart, qty is 0
            this.cart_qty = 0;
          }
        } else {
          // All items were removed from cart
          this.cart_qty = 0;
        }
        this.total_qty = this.cart_qty + this.quantity;
      });

      this.productForm = this.$root.querySelector(
        `[data-product-form-container]`,
      );

      const formEl = this.productForm.querySelector(".quick-buy-product-form");

      if (formEl !== null) {
        formEl.addEventListener("submit", this.submitForm.bind(this));
      }

      //check if window is /cart page
      this.isCartPage = window.location.pathname === "/cart";
    },
    resetHover: function resetHover() {
      this.hover = false;
      this.current_media = window.matchMedia("(max-width: 767px)").matches
        ? 1
        : 2;
    },
    onFocusOut: function onFocusOut(event) {
      var productGridItem = event.target.closest("[data-product-grid-item]");

      if (productGridItem && !productGridItem.contains(event.relatedTarget)) {
        this.resetHover();
      }
    },
    dispatchInputChange() {
      this.$refs.quantityInput.dispatchEvent(
        new Event("change", { bubbles: true }),
      );
      this.total_qty = this.cart_qty + this.quantity;
    },
    decreaseQuantity() {
      this.quantity > 1 && this.quantity--;
      this.dispatchInputChange();
    },
    increaseQuantity() {
      this.quantity++;
      this.dispatchInputChange();
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;
      this.addedToCart = false;
      this.cartAddErrorMessage = null;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(evt.target);
      const formId = evt.target.getAttribute("id");

      let modalCart = theme.settings.cart_type === "drawer" && !this.isCartPage;

      const config = fetchConfigDefaults("application/javascript");

      if (modalCart) {
        formData.append(
          "sections",
          "drawer-cart-items,drawer-cart-footer,cart-item-count,cart-items-count",
        );
      } else if (this.isCartPage) {
        formData.append(
          "sections",
          "cart-items,cart-footer,cart-item-count,cart-items-count",
        );
      } else {
        formData.append("sections", "cart-item-count,cart-items-count");
      }

      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;

            let errors = data.errors || data.description;
            let message = data.description || data.message;

            document.body.dispatchEvent(
              new CustomEvent("switch:productform:adderror", {
                detail: {
                  source: "product-form",
                  sourceId: formId,
                  variantId: formData.get("id"),
                  errors,
                  message,
                },
              }),
            );

            return;
          }

          this.loading = false;
          this.addedToCart = true;
          this.cart_qty = this.quantity;
          this.total_qty = this.cart_qty + this.quantity;

          const afterAddEvent = new CustomEvent("switch:cart:afteradditem", {
            bubbles: true,
            detail: { response: data },
          });
          document.body.dispatchEvent(afterAddEvent);

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          if (typeof error === "string") {
            alert(error);
          } else {
            this.loading = false;

            if (error.json()) {
              error.json().then((a) => {
                this.loading = false;
                alert(a.description);
              });
            } else {
              console.error(error);
            }
          }
        });
    },
  };
};
